import React, { useEffect, useState } from "react";
import { read } from "../../store/reminder/reminderActions";
import { useDispatch, useSelector } from "react-redux";
import { Spin, Collapse, Row, Col, Space, Button, Typography } from "antd";
import { useParams } from "react-router-dom";
import RenewalSummary from "./RenewalSummary";
import TextMessages from "./TextMessages";
import EmailMessages from "./EmailMessages";
import AgentNotes from "./AgentNotes";
import { BackButton } from "../shared/BackButton";
import ChangeStatusModal from "./ChangeStatusModal";

const ReminderForm = () => {
  const { requestId } = useParams();

  //
  const [isChangeStatusModalOpen, setIsChangeStatusModalOpen] = useState(false);

  const handleStatusChange = (data) => {
    console.log("Status changed:", data);
    // Add your save logic here
    setIsChangeStatusModalOpen(false);
  };

  //
  const dispatch = useDispatch();

  //
  const selected = useSelector((state) => state.reminder.selected);
  const loading = useSelector((state) => state.reminder.selectedLoading);

  const getTextMessagesDeliveredSummary = (reason) => {
    if (!selected?.TextMessages) return "0(0)";
    const total = selected.TextMessages.filter(
      (msg) => msg.Reason === reason
    ).length;
    const delivered = selected.TextMessages.filter(
      (msg) => msg.Reason === reason && msg.DeliveryStatus === 4
    ).length;
    return `Delivered (${delivered} of ${total})`;
  };

  const getEmailsDeliveredSummary = (reason) => {
    if (!selected?.EmailMessages) return "0(0)";
    const total = selected.EmailMessages.filter(
      (msg) => msg.Reason === reason
    ).length;
    const delivered = selected.EmailMessages.filter(
      (msg) => msg.Reason === reason && msg.DeliveryStatus === 2
    ).length;
    return `Delivered (${delivered} of ${total})`;
  };

  const textMessagesPanelHeader = selected ? (
    <Row>
      <Col xs={24} sm={24} md={8} lg={8} xl={8} xxl={8}>
        <Typography.Text>
          Text Messages ({selected.TextMessages.length})
        </Typography.Text>
      </Col>
      <Col xs={24} sm={24} md={8} lg={8} xl={8} xxl={8}>
        <Typography.Text>
          Reminder:{" "}
          {loading ? (
            <Spin size="small" />
          ) : (
            <Typography.Text>
              {getTextMessagesDeliveredSummary(0, "Reminder")}
            </Typography.Text>
          )}
        </Typography.Text>
      </Col>
      <Col xs={24} sm={24} md={8} lg={8} xl={8} xxl={8}>
        <Typography.Text>
          Thank You:{" "}
          {loading ? (
            <Spin size="small" />
          ) : (
            <Typography.Text>
              {getTextMessagesDeliveredSummary(1, "Thank You")}
            </Typography.Text>
          )}
        </Typography.Text>
      </Col>
    </Row>
  ) : (
    "Text Messages"
  );
  const emailMessagesPanelHeader = selected ? (
    <Row>
      <Col xs={24} sm={24} md={8} lg={8} xl={8} xxl={8}>
        <Typography.Text>
          Emails ({selected.EmailMessages.length})
        </Typography.Text>
      </Col>
      <Col xs={24} sm={24} md={8} lg={8} xl={8} xxl={8}>
        <Typography.Text>
          Reminder:{" "}
          {loading ? (
            <Spin size="small" />
          ) : (
            <Typography.Text>
              {getEmailsDeliveredSummary(5, "Reminder")}
            </Typography.Text>
          )}
        </Typography.Text>
      </Col>
      <Col xs={24} sm={24} md={8} lg={8} xl={8} xxl={8}>
        <Typography.Text>
          Thank You:{" "}
          {loading ? (
            <Spin size="small" />
          ) : (
            <Typography.Text>
              {getEmailsDeliveredSummary(6, "Thank You")}
            </Typography.Text>
          )}
        </Typography.Text>
      </Col>
    </Row>
  ) : (
    "Email Messages"
  );

  //
  const agentNotesPanelHeader = selected?.AgentNotes
    ? `Agent Notes (${selected.AgentNotes.length})`
    : "Agent Notes";

  //
  const defaultPanelKeys =
    selected?.AgentNotes.length == 0 ? ["1", "3"] : ["1", "2", "3"];

  //
  const { Panel } = Collapse;

  //
  useEffect(() => {
    console.log("requestId", requestId);
    if (requestId != null) {
      dispatch(read(requestId));
    }
  }, [requestId, dispatch]);

  return (
    <Spin spinning={!selected} delay={500}>
      {selected != null && (
        <>
          <Row style={{ paddingBottom: 4 }}>
            <Col span={16}>
              <Row>
                <Col>
                  <Space>
                    <BackButton
                      onGoBackHandler={() => {
                        {
                          /* parentRefreshHandler();
                        dispatch(clearSelectedAction()); */
                        }
                      }}
                    />
                    <Button
                      size="small"
                      disabled={loading}
                      loading={loading}
                      onClick={() => setIsChangeStatusModalOpen(true)}
                    >
                      Change Status
                    </Button>
                    <Button size="small" disabled={loading}>
                      Assign To Agent
                    </Button>

                    <Button
                      size="small"
                      disabled={loading}
                      onClick={() => {
                        reset();
                        trigger();
                      }}
                    >
                      Opt Out
                    </Button>
                    <Button
                      size="small"
                      type="dashed"
                      disabled={loading}
                      onClick={() => {
                        reset();
                        trigger();
                      }}
                    >
                      Opt Out Permanently
                    </Button>
                  </Space>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Collapse
                defaultActiveKey={defaultPanelKeys}
                type="card"
                size="small"
              >
                <Panel header="Summary" key={1}>
                  <RenewalSummary selected={selected} />
                </Panel>
                <Panel header={agentNotesPanelHeader} key={2}>
                  <AgentNotes notes={selected.AgentNotes} />
                </Panel>
                <Panel header={textMessagesPanelHeader} key={3}>
                  <TextMessages messages={selected.TextMessages} />
                </Panel>
                <Panel header={emailMessagesPanelHeader} key={4}>
                  <EmailMessages messages={selected.EmailMessages} />
                </Panel>
              </Collapse>
            </Col>
          </Row>
          <ChangeStatusModal
            isOpen={isChangeStatusModalOpen}
            onCancel={() => setIsChangeStatusModalOpen(false)}
            onSave={handleStatusChange}
            loading={loading}
            selected={selected}
          />
        </>
      )}
    </Spin>
  );
};

export default ReminderForm;
